export default (videoId) => {
  $('.modal-portfolio__side-bar__wrapper.active').removeClass('active')

  $('.modal-portfolio__side-bar__wrapper')
  .stop(true, true)
  .css('display', 'none')

  $(`[data-side-bar-id="${videoId}"]`)
  .addClass('active')
  .stop(true, true)
  .fadeIn('fast')
}
